import React from "react";
import { BRAND } from "@/lib/data";
import { ClipboardList, ShieldCheck, Send } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import LazyIframe from "@/components/LazyIframe";

export default function IntakePage() {
  useSeo({
    title: "Get Started — Intake Form",
    description:
      "Complete the ConnectHER intake form so we can show up prepared to your first meeting. 5–7 minutes, confidential and secure.",
    path: "/intake",
  });
  return (
    <>
      <section className="pt-16 md:pt-24 pb-10" data-testid="intake-hero">
        <div className="container-app max-w-4xl text-center">
          <div className="eyebrow">Get Started</div>
          <h1 className="mt-3 text-5xl md:text-6xl leading-tight">
            Tell us about your goals.
          </h1>
          <p className="mt-5 text-lg text-navy/70 max-w-2xl mx-auto leading-relaxed">
            Our secure intake form gathers the basics so we can show up to your
            first meeting prepared. Takes about 5–7 minutes.
          </p>
        </div>
      </section>

      <section className="pb-16" data-testid="intake-features">
        <div className="container-app grid sm:grid-cols-3 gap-4">
          {[
            { icon: ClipboardList, t: "5-7 minutes", d: "Short, structured, and saved as you go." },
            { icon: ShieldCheck, t: "Confidential", d: "Encrypted in transit and at rest." },
            { icon: Send, t: "We respond fast", d: "Expect a follow-up within one business day." },
          ].map((f, i) => (
            <div key={i} className="card p-6" data-testid={`intake-feature-${i}`}>
              <f.icon className="w-6 h-6 text-teal mb-3" />
              <h4 className="text-lg">{f.t}</h4>
              <p className="mt-1 text-sm text-navy/65">{f.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pb-20" data-testid="intake-embed-section">
        <div className="container-app">
          <div className="rounded-[2rem] overflow-hidden border border-navy/5 bg-white shadow-card">
            <LazyIframe
              testId="jotform-iframe"
              title="ConnectHER Intake Form"
              src={BRAND.jotformUrl}
              height={1000}
            />
          </div>
          <p className="mt-5 text-xs text-navy/50 text-center">
            Powered by Jotform. Trouble loading? Email us at{" "}
            <a className="text-gold" href={`mailto:${BRAND.emails.intake}`}>{BRAND.emails.intake}</a>.
          </p>
        </div>
      </section>
    </>
  );
}
